import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addNewScreenshot: {
    id: 'studio.HxIuLA',
    defaultMessage: 'Add screenshot',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: 'studio.wSZR47',
    defaultMessage: 'Submit',
  },
  screenshot: {
    id: 'studio.9a+SKt',
    defaultMessage: 'Screenshot',
  },
  noFile: {
    id: 'studio.KWwyi1',
    defaultMessage: 'No file selected',
  },
});
